/**
 * useUrlSync - URL パラメータと状態を同期
 */
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDashboard } from '../contexts/DashboardContext';

const DASHBOARD_PATH_RE = /^\/(?:meidaisai\/)?(?:en\/)?(purpose|function)\/?$/;

/**
 * URLパラメータとダッシュボード状態を同期
 */
export function useUrlSync() {
  const { pathname } = useLocation();
  const isDashboardPath = DASHBOARD_PATH_RE.test(pathname);
  const [searchParams, setSearchParams] = useSearchParams();
  const { 
    location, action, year, month, 
    setLocation, setAction, setYear, setMonth 
  } = useDashboard();
  
  // 初回: URLパラメータから状態を復元
  useEffect(() => {
    if (!isDashboardPath) return;

    const urlLocation = searchParams.get('location');
    const urlAction = searchParams.get('action');
    const urlYear = searchParams.get('year');
    const urlMonth = searchParams.get('month');
    
    if (urlLocation && urlLocation !== location) setLocation(urlLocation);
    if (urlAction && urlAction !== action) setAction(urlAction);
    if (urlYear && urlYear !== year) setYear(urlYear);
    if (urlMonth && urlMonth !== month) setMonth(urlMonth);
  }, [isDashboardPath]); // eslint-disable-line react-hooks/exhaustive-deps
  
  // 状態変更時: URLパラメータを更新
  useEffect(() => {
    if (!isDashboardPath) return;

    const params = new URLSearchParams();
    if (location) params.set('location', location);
    if (action) params.set('action', action);
    if (year) params.set('year', year);
    if (month) params.set('month', month);
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach((key) => {
      const value = searchParams.get(key);
      if (value) params.set(key, value);
    });
    
    // 現在のURLパラメータと比較して変更があれば更新
    const currentParams = searchParams.toString();
    const newParams = params.toString();
    
    if (currentParams !== newParams) {
      setSearchParams(params, { replace: true });
    }
  }, [isDashboardPath, location, action, year, month, searchParams, setSearchParams]);
}
